(() => {
  const SCORE_MAP = {
    atmosphere_fresh: { the_one: 17.5, ocean_breeze: 35, day_dream: 17.5, santal_woods: 0, cavero_royale: 20, praga_rouge: 35, milan_sereno: 0, malaga_suite: 0, london_nights: 17.5, soleil_dor: 35, adore_nuit: 0, maison_noir: 0 },
    atmosphere_calm: { the_one: 17.5, ocean_breeze: 17.5, day_dream: 35, santal_woods: 35, cavero_royale: 0, praga_rouge: 17.5, milan_sereno: 17.5, malaga_suite: 0, london_nights: 35, soleil_dor: 17.5, adore_nuit: 17.5, maison_noir: 35 },
    atmosphere_warm: { the_one: 35, ocean_breeze: 0, day_dream: 17.5, santal_woods: 17.5, cavero_royale: 35, praga_rouge: 0, milan_sereno: 35, malaga_suite: 35, london_nights: 0, soleil_dor: 17.5, adore_nuit: 35, maison_noir: 17.5 },
    direction_fresh: { the_one: 15, ocean_breeze: 30, day_dream: 0, santal_woods: 0, cavero_royale: 15, praga_rouge: 30, milan_sereno: 0, malaga_suite: 0, london_nights: 30, soleil_dor: 30, adore_nuit: 0, maison_noir: 0 },
    direction_floral: { the_one: 15, ocean_breeze: 15, day_dream: 30, santal_woods: 15, cavero_royale: 0, praga_rouge: 15, milan_sereno: 30, malaga_suite: 0, london_nights: 15, soleil_dor: 30, adore_nuit: 15, maison_noir: 15 },
    direction_warm: { the_one: 30, ocean_breeze: 0, day_dream: 15, santal_woods: 30, cavero_royale: 30, praga_rouge: 0, milan_sereno: 30, malaga_suite: 31, london_nights: 0, soleil_dor: 15, adore_nuit: 31, maison_noir: 30 },
    room_living: { the_one: 20, ocean_breeze: 10, day_dream: 10, santal_woods: 10, cavero_royale: 20, praga_rouge: 20, milan_sereno: 20, malaga_suite: 20, london_nights: 10, soleil_dor: 20, adore_nuit: 10, maison_noir: 10 },
    room_bedroom: { the_one: 10, ocean_breeze: 10, day_dream: 20, santal_woods: 20, cavero_royale: 0, praga_rouge: 10, milan_sereno: 20, malaga_suite: 10, london_nights: 20, soleil_dor: 10, adore_nuit: 20, maison_noir: 10 },
    room_utility: { the_one: 10, ocean_breeze: 20, day_dream: 10, santal_woods: 10, cavero_royale: 10, praga_rouge: 20, milan_sereno: 10, malaga_suite: 10, london_nights: 20, soleil_dor: 10, adore_nuit: 0, maison_noir: 20 },
    intensity_subtle: { the_one: 7.5, ocean_breeze: 15, day_dream: 15, santal_woods: 15, cavero_royale: 0, praga_rouge: 7.5, milan_sereno: 7.5, malaga_suite: 0, london_nights: 15, soleil_dor: 7.5, adore_nuit: 7.5, maison_noir: 7.5 },
    intensity_balanced: { the_one: 15, ocean_breeze: 15, day_dream: 15, santal_woods: 15, cavero_royale: 7.5, praga_rouge: 15, milan_sereno: 15, malaga_suite: 7.5, london_nights: 15, soleil_dor: 15, adore_nuit: 15, maison_noir: 15 },
    intensity_strong: { the_one: 15, ocean_breeze: 7.5, day_dream: 7.5, santal_woods: 7.5, cavero_royale: 15, praga_rouge: 7.5, milan_sereno: 15, malaga_suite: 15, london_nights: 7.5, soleil_dor: 7.5, adore_nuit: 15, maison_noir: 7.5 }
  };

  Object.assign(SCORE_MAP, {
    character_sea: { ocean_breeze: 55, praga_rouge: 10, soleil_dor: 10 },
    character_tea: { day_dream: 48, london_nights: 55 },
    character_powder: { santal_woods: 55, maison_noir: 55, milan_sereno: 20 },
    character_spice: { the_one: 50, cavero_royale: 55, milan_sereno: 55 },
    character_oud: { malaga_suite: 55, cavero_royale: 15, maison_noir: 15 },
    character_fruit: { praga_rouge: 55, adore_nuit: 15, soleil_dor: 15 },
    character_flowers: { soleil_dor: 55, milan_sereno: 25, santal_woods: 15 },
    character_vanilla: { adore_nuit: 55, day_dream: 35 }
  });

  const rankAvailableProducts = ({ products = [], selectedValues = [], avoid = [], availableOnly = false }) => {
    const scores = Object.fromEntries(products.map((product) => [product.id, 0]));

    selectedValues.forEach((value) => {
      const weights = SCORE_MAP[value] || {};
      Object.entries(weights).forEach(([id, points]) => {
        scores[id] = (scores[id] || 0) + points;
      });
    });

    const availableProducts = products.filter(
      (product) =>
        (!availableOnly || product.available === true) &&
        typeof product.url === 'string' &&
        product.url.trim().length > 0
    );
    const preferredProducts = availableProducts.filter(
      (product) => !product.avoid?.some((value) => avoid.includes(value))
    );
    // Respect exclusions even when no available fragrance remains.
    const recommendationPool = preferredProducts;

    return recommendationPool
      .map((product) => {
        const answers = selectedValues.filter(value => SCORE_MAP[value]);
        const fitValues = answers.filter(value => (SCORE_MAP[value][product.id] || 0) >= Math.max(...Object.values(SCORE_MAP[value])) * 0.75);
        const coreAnswers = answers.filter(value => /^(direction|character)_/.test(value));
        const conflictValues = coreAnswers.filter(value => !(SCORE_MAP[value][product.id] > 0));
        return { ...product, score: scores[product.id] || 0, fitValues, conflictValues,
          coreFit: coreAnswers.some(value => (SCORE_MAP[value][product.id] || 0) >= 15) };
      })
      .sort((a, b) => b.score - a.score || Number(b.available) - Number(a.available));
  };

  const rankPacks = ({ packs = [], ranked = [] }) => packs
    .map((pack) => {
      const members = (pack.members || []).map(id => ranked.find(p => p.id === id));
      // Every component must be known and pass the visitor's exclusions.
      if (!pack.url || members.length !== 3 || new Set(pack.members).size !== 3 || members.some(p => !p)) return null;
      // A good average must not conceal a weak third fragrance.
      if (members.some(p => !p.coreFit || p.score < 60)) return null;
      return { ...pack, memberProducts: members, weakestScore: Math.min(...members.map(p => p.score)), score: members.reduce((sum,p) => sum + p.score, 0) / 3 };
    })
    .filter(Boolean)
    .sort((a,b) => b.weakestScore - a.weakestScore || b.score - a.score || Number(b.available) - Number(a.available));

  const shouldShowProductMatch = (primary) => Boolean(primary);

  const publish = (name, payload = {}) => {
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_error) {
      // Analytics must never block the guide.
    }
  };

  const setText = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element) element.textContent = value || '';
  };

  const initGuide = (root) => {
    if (root.dataset.pwReady === 'true') return;
    root.dataset.pwReady = 'true';

    const intro = root.querySelector('[data-pw-panel="intro"]');
    const questionsPanel = root.querySelector('[data-pw-panel="questions"]');
    const resultPanel = root.querySelector('[data-pw-panel="result"]');
    const form = root.querySelector('[data-pw-form]');
    const questions = [...root.querySelectorAll('[data-pw-question]')];
    const startButton = root.querySelector('[data-pw-start]');
    const nextButton = root.querySelector('[data-pw-next]');
    const backButton = root.querySelector('[data-pw-back]');
    const restartButton = root.querySelector('[data-pw-restart]');
    const editButton = root.querySelector('[data-pw-edit]');
    const progress = root.querySelector('[data-pw-progress]');
    const progressBar = root.querySelector('[data-pw-progress-bar]');
    const progressText = root.querySelector('[data-pw-progress-text]');
    const live = root.querySelector('[data-pw-live]');
    const productsNode = root.querySelector('[data-pw-products]');
    let currentIndex = 0;
    let products = [];
    let packs = [];
    const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';

    try {
      products = JSON.parse(productsNode?.textContent || '[]');
      packs = JSON.parse(root.querySelector('[data-pw-packs]')?.textContent || '[]');
    } catch (_error) {
      products = [];
    }

    const showPanel = (panel) => {
      [intro, questionsPanel, resultPanel].forEach((item) => {
        if (item) item.hidden = item !== panel;
      });
    };

    const selectedFor = (question) =>
      question.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');

    const updateQuestion = ({ announce = true } = {}) => {
      const viewport = { left: window.scrollX, top: window.scrollY };
      // A shorter question must not shrink the page beneath the current viewport.
      if (questionsPanel && !questionsPanel.hidden) {
        questionsPanel.style.minHeight = `${questionsPanel.getBoundingClientRect().height}px`;
        questionsPanel.style.overflowAnchor = 'none';
      }
      questions.forEach((question, index) => {
        question.hidden = index !== currentIndex;
        question.dataset.progress = `${root.dataset.progressQuestion} ${index + 1} ${root.dataset.progressOf} ${questions.length}`;
      });

      const active = questions[currentIndex];
      const optional = active?.dataset.optional === 'true';
      const stepLabel = `${root.dataset.progressQuestion} ${currentIndex + 1} ${root.dataset.progressOf} ${questions.length}`;
      if (progressText) progressText.textContent = stepLabel;
      if (progress) {
        const visualStep = currentIndex + 1;
        progress.setAttribute('aria-valuenow', String(visualStep));
        progress.setAttribute('aria-valuemax', String(questions.length));
        progress.setAttribute('aria-valuetext', stepLabel);
      }
      if (progressBar) {
        const percentage = ((currentIndex + 1) / questions.length) * 100;
        progressBar.style.width = `${percentage}%`;
      }

      if (backButton) backButton.hidden = currentIndex === 0;
      if (nextButton) {
        nextButton.disabled = optional ? false : !selectedFor(active);
        nextButton.textContent = currentIndex === questions.length - 1 ? nextButton.dataset.resultLabel : nextButton.dataset.nextLabel;
      }

      const legend = active?.querySelector('legend');
      if (legend) {
        legend.setAttribute('tabindex', '-1');
        legend.focus({ preventScroll: true });
      }
      if (announce && live) live.textContent = `${stepLabel}: ${legend?.textContent || ''}`;
      // Resolve layout and preserve position without a smooth scroll or browser anchoring.
      window.scrollTo({ ...viewport, behavior: 'instant' });
    };

    if (nextButton) {
      nextButton.dataset.nextLabel = nextButton.textContent.trim();
      nextButton.dataset.resultLabel = root.dataset.resultLabel || nextButton.textContent.trim();
    }

    const confidenceLabel = (scores) => {
      const top = scores[0]?.score || 0;
      const gap = top - (scores[1]?.score || 0);
      if (scores[0]?.conflictValues?.length) return root.dataset.multipleMatch;
      if (top >= 115 && gap >= 12) return root.dataset.strongMatch;
      if (top >= 90 || gap >= 8) return root.dataset.goodMatch;
      return root.dataset.multipleMatch;
    };

    const explain = (product) => {
      const labels = values => (values || []).map(value => {
        const input = [...form.querySelectorAll('input:checked')].find(item => item.value === value);
        const option = input?.closest('label');
        return (option?.querySelector('.pw-scent-option__title') || option?.querySelector('span'))?.textContent.trim();
      }).filter(Boolean).join(' · ');
      const priority = value => value.startsWith('character_') ? 0 : value.startsWith('direction_') ? 1 : 2;
      const matching = labels([...(product.fitValues || [])].sort((a,b) => priority(a) - priority(b)).slice(0,3));
      const conflicting = labels(product.conflictValues);
      return [matching ? `${root.dataset.fitLabel}: ${matching}.` : root.dataset.mixedLabel,
        conflicting ? `${root.dataset.tradeoffLabel}: ${conflicting}.` : ''].filter(Boolean).join(' ');
    };

    const getRecommendation = () => {
      const selectedValues = [...form.querySelectorAll('input[type="radio"]:checked')].map(
        (input) => input.value
      );

      const avoid = [...form.querySelectorAll('input[name="avoid"]:checked')]
        .map((input) => input.value)
        .filter((value) => value !== 'none');

      return rankAvailableProducts({ products, selectedValues, avoid });
    };

    const renderAlternatives = (ranked) => {
      const wrapper = root.querySelector('[data-pw-alternatives-wrap]');
      const list = root.querySelector('[data-pw-alternatives]');
      if (!wrapper || !list) return;
      list.replaceChildren();
      ranked.slice(1, 3).forEach((product) => {
        const link = document.createElement('a');
        link.className = 'pw-scent-result__alternative';
        link.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.width = 96;
          image.height = 96;
          image.loading = 'lazy';
          link.append(image);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = product.name;
        const profile = document.createElement('span');
        profile.textContent = product.profile;
        const notes = document.createElement('small');
        notes.textContent = product.notes;
        copy.append(title, profile, notes);
        const stock = document.createElement('small');
        stock.textContent = product.available ? root.dataset.stockAvailable : root.dataset.stockUnavailable;
        copy.append(stock);
        link.append(copy);
        link.addEventListener('click', () => {
          publish('pw_scent_quiz_recommendation_clicked', {
            recommendation_id: product.id,
            placement: 'alternative'
          });
        });
        list.append(link);
      });
      wrapper.hidden = list.childElementCount === 0;
    };

    const renderResult = () => {
      const ranked = getRecommendation();
      const match = root.querySelector('[data-pw-match]');
      const noMatch = root.querySelector('[data-pw-no-match]');
      const primary = ranked[0];

      const packPanel = root.querySelector('[data-pw-pack]');
      const packCard = root.querySelector('[data-pw-pack-card]');
      const packEmpty = root.querySelector('[data-pw-pack-empty]');
      const format = form.querySelector('input[name="format"]:checked')?.value || 'both';
      const rankedPacks = rankPacks({ packs, ranked });
      if (packPanel) packPanel.hidden = format === 'single';
      if (packCard) {
        packCard.replaceChildren();
        const best = rankedPacks[0];
        if (packEmpty) packEmpty.hidden = Boolean(best);
        // Keep duplicate compositions visible as purchase options, without treating them as different scent matches.
        const choices = best ? rankedPacks.filter(p => [...p.members].sort().join() === [...best.members].sort().join()) : [];
        choices.slice(0, 1).forEach(pack => {
          const article = document.createElement('article');
          article.className = 'pw-scent-support-card';
          const heading = document.createElement('h3');
          heading.textContent = pack.name;
          if (pack.image) {
            const image = document.createElement('img');
            image.src = pack.image; image.alt = ''; image.width = 180; image.height = 180;
            image.loading = 'lazy'; article.append(image);
          }
          article.append(heading);
          const list = document.createElement('ul');
          pack.memberProducts.forEach(member => {
            const li = document.createElement('li');
            li.textContent = `${member.name} — ${member.profile}`;
            const reason = document.createElement('p');
            reason.className = 'pw-scent-result__guidance';
            reason.textContent = explain(member);
            li.append(reason);
            list.append(li);
          });
          const stock = document.createElement('p');
          stock.className = 'pw-scent-stock';
          stock.textContent = pack.available ? root.dataset.stockAvailable : root.dataset.stockUnavailable;
          const link = document.createElement('a');
          link.className = 'pw-scent-button pw-scent-button--primary'; link.href = pack.url;
          link.textContent = root.dataset.packView;
          link.addEventListener('click',()=>publish('pw_scent_quiz_recommendation_clicked',{recommendation_id:pack.id,placement:'pack'}));
          const contents = document.createElement('p');
          contents.textContent = pack.memberProducts.map(member => member.name).join(' · ');
          const explanation = document.createElement('details');
          explanation.className = 'pw-scent-disclosure';
          const explanationTitle = document.createElement('summary');
          explanationTitle.textContent = root.dataset.packReasonLabel;
          explanation.append(explanationTitle,list);
          article.append(contents,stock,link,explanation);
          if (choices.length > 1) {
            const versions = document.createElement('details');
            versions.className = 'pw-scent-disclosure';
            const versionsTitle = document.createElement('summary');
            versionsTitle.textContent = root.dataset.packVersionsLabel;
            versions.append(versionsTitle);
            choices.slice(1).forEach(version => {
              const option = document.createElement('p');
              const optionLink = document.createElement('a');
              optionLink.className = 'pw-scent-text-link';
              optionLink.href = version.url; optionLink.textContent = version.name;
              optionLink.addEventListener('click',()=>publish('pw_scent_quiz_recommendation_clicked',{recommendation_id:version.id,placement:'pack_version'}));
              const availability = document.createElement('span');
              availability.textContent = ' — ' + (version.available ? root.dataset.stockAvailable : root.dataset.stockUnavailable);
              option.append(optionLink,availability); versions.append(option);
            });
            article.append(versions);
          }
          packCard.append(article);
        });
      }

      const singlePanel = root.querySelector('[data-pw-single-disclosure]');
      resultPanel.querySelectorAll('details').forEach(detail => { detail.open = false; });
      const packIsPrimary = format === 'pack' && rankedPacks.length > 0;
      if (singlePanel) {
        singlePanel.open = !packIsPrimary;
        singlePanel.hidden = !primary;
        if (packIsPrimary) resultPanel.prepend(packPanel);
        else resultPanel.prepend(singlePanel);
      }
      if (packPanel) packPanel.open = format === 'pack';
      showPanel(resultPanel);
      const summary = root.querySelector('[data-pw-summary]');
      if (summary) {
        summary.replaceChildren();
        questions.forEach((question, index) => {
          const checked = [...question.querySelectorAll('input:checked')];
          if (!checked.length) return;
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pw-scent-summary__answer';
          const label = checked.map((input) => {
            const option = input.closest('label');
            return (option.querySelector('.pw-scent-option__title') || option.querySelector('span'))?.textContent.trim();
          }).join(', ');
          button.textContent = label;
          button.setAttribute('aria-label', `${editButton?.textContent.trim() || ''}: ${question.querySelector('legend')?.textContent.trim()}. ${label}`);
          button.addEventListener('click', () => editAnswers(index));
          item.append(button);
          summary.append(item);
        });
      }
      // A gift set has its own scents and must not bypass explicit exclusions.
      const giftCard = root.querySelector('[data-pw-gift-card]');
      if (giftCard) giftCard.hidden = true;
      if (!shouldShowProductMatch(primary)) {
        if (match) match.hidden = true;
        if (noMatch) noMatch.hidden = false;
        publish('pw_scent_quiz_completed', { recommendation_id: 'no_clear_match' });
      } else {
        if (match) match.hidden = false;
        if (noMatch) noMatch.hidden = true;
        setText(root, '[data-pw-result-title]', primary.name);
        setText(root, '[data-pw-stock]', primary.available ? root.dataset.stockAvailable : root.dataset.stockUnavailable);
        setText(root, '[data-pw-confidence]', confidenceLabel(ranked));
        setText(root, '[data-pw-result-why]', primary.why);
        setText(root, '[data-pw-personal-reason]', explain(primary));
        setText(root, '[data-pw-result-profile]', primary.profile);
        setText(root, '[data-pw-result-notes]', primary.notes);
        setText(root, '[data-pw-result-rooms]', primary.rooms);

        const image = root.querySelector('[data-pw-result-image]');
        if (image) {
          image.hidden = !primary.image;
          if (primary.image) {
            image.src = primary.image;
            image.alt = primary.imageAlt || primary.name;
          }
        }

        const productLink = root.querySelector('[data-pw-result-link]');
        if (productLink) {
          productLink.href = primary.url;
          productLink.onclick = () => {
            publish('pw_scent_quiz_recommendation_clicked', {
              recommendation_id: primary.id,
              placement: 'primary'
            });
          };
        }

        renderAlternatives(ranked);
        publish('pw_scent_quiz_completed', {
          recommendation_id: primary.id,
          confidence: confidenceLabel(ranked)
        });
      }

      resultPanel?.focus({ preventScroll: true });
      resultPanel?.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
    };

    startButton?.addEventListener('click', () => {
      currentIndex = 0;
      showPanel(questionsPanel);
      updateQuestion({ announce: false });
      questionsPanel?.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      publish('pw_scent_quiz_started');
    });

    const editAnswers = (index = 0) => {
      currentIndex = index;
      showPanel(questionsPanel);
      updateQuestion();
      questionsPanel?.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
    };
    editButton?.addEventListener('click', () => editAnswers());
    form?.addEventListener('submit', (event) => event.preventDefault());

    form?.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      if (input.matches('[data-pw-none]') && input.checked) {
        form.querySelectorAll('input[name="avoid"]:not([data-pw-none])').forEach((checkbox) => {
          checkbox.checked = false;
        });
      } else if (input.name === 'avoid' && input.checked) {
        const none = form.querySelector('[data-pw-none]');
        if (none) none.checked = false;
      }

      const active = questions[currentIndex];
      if (nextButton && active?.dataset.optional !== 'true') nextButton.disabled = !selectedFor(active);
    });

    nextButton?.addEventListener('click', () => {
      const active = questions[currentIndex];
      if (active?.dataset.optional !== 'true' && !selectedFor(active)) return;

      if (currentIndex < questions.length - 1) {
        publish('pw_scent_quiz_question_completed', { question_number: currentIndex + 1 });
        currentIndex += 1;
        updateQuestion();
      } else {
        renderResult();
      }
    });

    backButton?.addEventListener('click', () => {
      if (currentIndex === 0) return;
      currentIndex -= 1;
      updateQuestion({ announce: false });
    });

    restartButton?.addEventListener('click', () => {
      form?.reset();
      currentIndex = 0;
      showPanel(intro);
      intro?.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      startButton?.focus({ preventScroll: true });
      publish('pw_scent_quiz_restarted');
    });
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { SCORE_MAP, rankAvailableProducts, rankPacks, shouldShowProductMatch };
  }

  if (typeof document === 'undefined') return;

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pw-scent-quiz]').forEach(initGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
